import PublicProgramLegalFiles from "./PublicProgramLegalFiles";

const PROGRAM_TITLES = {
  5: {
    2025: "Πρόγραμμα 5: Παροχή Χρηματικών Βοηθημάτων σε Τρίτεκνες και Πολύτεκνες Μητέρες",
    2026: "Πρόγραμμα 5: Παροχή Χρηματικών Βοηθημάτων – Βραβείων σε Τρίτεκνες και Πολύτεκνες Μητέρες",
  },
  6: {
    2025: "Πρόγραμμα 6: Υποτροφίες Επιτυχόντων Τέκνων στις Πανελλαδικές Εξετάσεις",
    2026: "Παροχή Χρηματικών Βραβείων - Υποτροφίες",
  },
};

const PROGRAM_5_DETAILS = {
  2025: {
    polyteknes: "εξακόσιες (600)",
    triteknes: "δύο χιλιάδες πεντακόσιες (2.500)",
    referenceYear: "2024",
    includesSingleFathers: false,
  },
  2026: {
    polyteknes: "εξακόσιες (600)",
    triteknes: "δύο χιλιάδες τριακόσιες (2.300)",
    referenceYear: "2025",
    includesSingleFathers: true,
  },
};

const PROGRAM_6_DETAILS = {
  2025: {
    beneficiaries: "εξακόσια πενήντα (650)",
    referenceYear: "2024",
  },
};

export const getPublicProgramTitle = (programNumber, year) =>
  PROGRAM_TITLES[programNumber][year];

const EligibilityRequirements = ({
  referenceYear,
  includesSingleFathers = false,
}) => (
  <>
    <p>
      <strong>Προϋποθέσεις: </strong>
      Δικαίωμα συμμετοχής έχουν τρίτεκνες και πολύτεκνες μητέρες
      {includesSingleFathers ? " ή μονογονείς πατέρες αντίστοιχα" : ""}, εφόσον:
    </p>
    <ul style={{ listStyleType: "disc", paddingLeft: 20 }}>
      <li style={{ fontSize: "1.05rem", marginBottom: 12 }}>
        Είναι ασφαλισμένες{includesSingleFathers ? "/οι" : ""} του e-ΕΦΚΑ (ΟΓΑ)
        και ασφαλιστικά ενήμερες{includesSingleFathers ? "/οι" : ""} κατά την{" "}
        <strong>31η Δεκεμβρίου {referenceYear}</strong>, ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: 12 }}>
        Είναι συνταξιούχοι του e-ΕΦΚΑ (ΟΓΑ), ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: 12 }}>
        Είναι συνταξιούχοι του Λογαριασμού Ανασφάλιστων Υπερηλίκων του άρθρου 1
        του ν.1296/1982 (ΦΕΚ 128 Α’), όπως ισχύει, ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: 12 }}>
        Είναι υπάλληλοι ή/και συνταξιούχοι πρώην υπάλληλοι του ΟΠΕΚΑ, με την
        προϋπόθεση ότι καταβάλλουν τις προβλεπόμενες εισφορές, ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: 12 }}>
        Είναι υπάλληλοι του e-ΕΦΚΑ που μεταφέρθηκαν από τον ΟΓΑ, ήταν
        εγγεγραμμένοι στο Μητρώο Δικαιούχων του ΛΑΕ και εξακολουθούν να
        καταβάλλουν τις προβλεπόμενες εισφορές
        {includesSingleFathers
          ? ", παραμένουν υπάλληλοι του e-ΕΦΚΑ και έχουν τρία ή περισσότερα τέκνα που είναι δικαιούχοι των παροχών του ΛΑΕ/ΟΠΕΚΑ"
          : ""}
        .
      </li>
    </ul>
  </>
);

const ApplicationDeclaration = () => (
  <p>
    <strong>
      Κάθε αίτηση που υποβάλλεται ηλεκτρονικά επέχει θέση υπεύθυνης δήλωσης{" "}
    </strong>
    του άρθρου 8 του ν. 1599/1986 (ΦΕΚ 75 Α΄) για τα στοιχεία που περιέχονται σε
    αυτήν.
  </p>
);

const Program5Info = ({ year }) => {
  const details = PROGRAM_5_DETAILS[year];

  return (
    <>
      <p>
        Ο ΛΑΕ/ΟΠΕΚΑ υλοποιεί το <strong>Πρόγραμμα 5</strong> παροχής χρηματικών
        βοηθημάτων – βραβείων σε{" "}
        <strong>τρίτεκνες και πολύτεκνες μητέρες</strong>, συνταξιούχους ή
        ασφαλισμένες του e-ΕΦΚΑ (ΟΓΑ)
        {details.includesSingleFathers ? (
          <>
            , καθώς και σε <strong>μονογονείς πατέρες</strong>, με τις ίδιες
            προϋποθέσεις
          </>
        ) : null}
        .
      </p>

      <p>
        Το πρόγραμμα απευθύνεται σε{" "}
        <strong>
          {details.polyteknes} πολύτεκνες και {details.triteknes} τρίτεκνες
          μητέρες
        </strong>
        {details.includesSingleFathers ? (
          <>
            , ή αντίστοιχα <strong>μονογονείς πατέρες</strong>
          </>
        ) : null}
        .
      </p>

      <p>
        Οι δικαιούχοι πρέπει να έχουν ενεργή ασφαλιστική ικανότητα. Ειδικότερα,
        το δικαίωμα περίθαλψης των τέκνων πρέπει να απορρέει από δικαιούχο του
        ΛΑΕ/ΟΠΕΚΑ.
      </p>

      <p>
        Σε περίπτωση ενδιαφέροντος πέραν του καθορισμένου αριθμού ανά κατηγορία,
        η επιλογή γίνεται με <strong>κλήρωση</strong>, σύμφωνα με τη διαδικασία
        που ορίζεται με απόφαση του Δ.Σ. του ΟΠΕΚΑ.
      </p>

      <EligibilityRequirements
        referenceYear={details.referenceYear}
        includesSingleFathers={details.includesSingleFathers}
      />

      {year === "2026" ? (
        <p>
          Το ποσό του χρηματικού βοηθήματος – βραβείου ανέρχεται σε 700 ευρώ για
          τις <strong>τρίτεκνες</strong> και 1.000 ευρώ για τις{" "}
          <strong>πολύτεκνες</strong> μητέρες, ή τους{" "}
          <strong>μονογονείς πατέρες</strong> αντίστοιχα.
        </p>
      ) : (
        <p>
          Το ποσό των χρηματικών βραβείων καθορίζεται με απόφαση της
          Διαχειριστικής Επιτροπής του ΛΑΕ, σύμφωνα με το άρθρο 3 του
          ν.3050/2002.
        </p>
      )}

      <ApplicationDeclaration />
      <PublicProgramLegalFiles programNumber={5} year={year} />
    </>
  );
};

const Program6Info = ({ year }) => {
  if (year === "2026") {
    return (
      <>
        <h2 style={{ fontSize: "1.35rem", lineHeight: 1.4 }}>
          Πρόγραμμα Χρηματικών Βραβείων/Υποτροφιών σε επιτυχόντες/ούσες
          μαθητές/τριες στις Πανελλαδικές Εξετάσεις 2026
        </h2>

        <p>
          Ο ΛΑΕ/ΟΠΕΚΑ χορηγεί χρηματικά βραβεία/υποτροφίες σε επιτυχόντες/ούσες
          μαθητές/τριες στις Πανελλαδικές Εξετάσεις για πρώτη φορά το έτος 2026
          σε δημόσια Ανώτατα Εκπαιδευτικά Ιδρύματα της ημεδαπής, δικαιούχους του
          ΛΑΕ/ΟΠΕΚΑ, με άμεσο ή έμμεσο δικαίωμα.
        </p>

        <p>
          <div style={{ fontSize: "1rem", lineHeight: 1.6, color: "#222" }}>
            <p>
              Δικαιούχοι της παροχής είναι δύο χιλιάδες εκατόν έξι (2.106) τέκνα
              που είναι άμεσα ή έμμεσα (εξαρτώμενα μέλη) δικαιούχοι του
              ΛΑΕ/ΟΠΕΚΑ, εφόσον:
            </p>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li style={{ marginBottom: 10 }}>
                <strong>α)</strong> είχαν τη μαθητική ιδιότητα για το σχολικό
                έτος 2025-2026 και
              </li>
              <li style={{ marginBottom: 10 }}>
                <strong>β)</strong> είναι άγαμα και άνεργα και
              </li>
              <li style={{ marginBottom: 10 }}>
                <strong>γ)</strong> εγγράφονται για πρώτη φορά σε δημόσιο
                Ανώτατο Εκπαιδευτικό Ίδρυμα της ημεδαπής, έχοντας επιτύχει στις
                πανελλαδικές εξετάσεις το έτος 2026 (ή μέσω κάθε άλλης
                διαδικασίας που εξομοιώνεται με τις πανελλαδικές εξετάσεις από
                το αρμόδιο Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού).
              </li>
            </ul>
            <p>
              <strong>Σημειώνεται ότι:</strong>
            </p>
            <ul style={{ listStyleType: "disc", paddingLeft: 22 }}>
              <li style={{ marginBottom: 10 }}>
                <strong>Άμεσα μέλη</strong> λογίζονται τα τέκνα που έχουν δικό
                τους δικαίωμα ασφάλισης ως δικαιούχοι ορφανικής σύνταξης ή
                σύνταξης αναπηρίας (τέκνο ανίκανο για κάθε εργασία), ή
                επιδόματος παραπληγίας-τετραπληγίας (παραπληγικό επίδομα) του
                e-ΕΦΚΑ (ΟΓΑ).
              </li>
              <li>
                <strong>Εξαρτώμενα μέλη</strong> λογίζονται τα τέκνα που
                ασφαλίζονται έμμεσα από τον ίδιο άμεσο δικαιούχο των παροχών του
                ΛΑΕ/ΟΠΕΚΑ, ή και τον έτερο γονέα τους, εφόσον και αυτός είναι
                άμεσα δικαιούχος των παροχών του ΛΑΕ/ΟΠΕΚΑ.
              </li>
            </ul>
          </div>
        </p>

        <p>
          Η αίτηση συμμετοχής υποβάλλεται από τον άμεσα δικαιούχο των παροχών
          του ΛΑΕ/ΟΠΕΚΑ γονέα του τέκνου που έχει τις προϋποθέσεις να καταστεί
          δικαιούχος.
        </p>

        <ApplicationDeclaration />
        <PublicProgramLegalFiles programNumber={6} year={year} />
      </>
    );
  }

  const details = PROGRAM_6_DETAILS[year];

  return (
    <>
      <p>
        Ο ΛΑΕ/ΟΠΕΚΑ υλοποιεί το <strong>Πρόγραμμα 6</strong> υποτροφίας{" "}
        <strong>
          επιτυχόντων για πρώτη φορά στις Πανελλαδικές Εξετάσεις τέκνων
          τρίτεκνων και πολύτεκνων μητέρων
        </strong>
        .
      </p>

      <p>
        Το πρόγραμμα απευθύνεται σε{" "}
        <strong>
          {details.beneficiaries} επιτυχόντα για πρώτη φορά στις Πανελλαδικές
          Εξετάσεις τέκνα τρίτεκνων και πολύτεκνων μητέρων
        </strong>
        . Οι μητέρες υποβάλλουν τις σχετικές αιτήσεις και πρέπει να πληρούν τις
        προϋποθέσεις συμμετοχής του Προγράμματος 5.
      </p>

      <p>
        Σε περίπτωση ενδιαφέροντος πέραν του καθορισμένου αριθμού, η επιλογή
        γίνεται με <strong>κλήρωση</strong>, σύμφωνα με τη διαδικασία που
        ορίζεται με απόφαση του Δ.Σ. του ΟΠΕΚΑ.
      </p>

      <EligibilityRequirements referenceYear={details.referenceYear} />
      <ApplicationDeclaration />
      <PublicProgramLegalFiles programNumber={6} year={year} />
    </>
  );
};

export default function PublicProgramInfoContent({ programNumber, year }) {
  return programNumber === 5 ? (
    <Program5Info year={year} />
  ) : (
    <Program6Info year={year} />
  );
}
